@if (isEditMode) {
<div class="fallback-container d-flex justify-content-center align-items-center mt-3 m- mb-3">
  <div class="row">
    <div class="col-3 d-flex align-items-center justify-content-end">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        fill="red"
        class="bi bi-exclamation-circle-fill"
        viewBox="0 0 16 16"
      >
        <path
          d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4m.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
        />
      </svg>
    </div>
    <div class="col-9 pr-5 text-break d-flex align-items-center">
      @if (blockEditorContent) {
      <h3>You don&apos;t have a component for the content type: {{ blockEditorContent?.type }}</h3>
      } @else {
      <h3>You don&apos;t have a component for the content type: {{ contentlet?.contentType }}</h3>
      }
    </div>
  </div>
</div>
}
